'use client';

import {
  CatIconWarningCircle,
  CatInlineNotification
} from 'components/blocks-components';
import cx from 'classnames';
import styles from './parts-diagram-error.module.scss';

interface PartsDiagramErrorProps {
  errorTitle: string;
  errorDesc: string;
}

const PartsDiagramError = ({
  errorTitle,
  errorDesc
}: PartsDiagramErrorProps) => {
  return (
    <div className="my-4">
      <CatInlineNotification variant="error" heading={errorTitle} dismissible>
        <CatIconWarningCircle slot="before" />
        <p
          className={cx(
            'cat-u-theme-typography-body-sm mb-0',
            styles['error-message-description__label']
          )}
        >
          {errorDesc}
        </p>
      </CatInlineNotification>
    </div>
  );
};

export default PartsDiagramError;
